// Modules
import { produce } from 'immer'

// Constants
import { appLanguages, appLanguagesLocalStoreKey } from 'components/LanguageDropdown/constants'
import { sidebarConstants } from 'pages/User/components/Sidebar/constants'

import { localStorageActiveUserTradeAccountKey } from 'constants/index'

import { themeColorMode, themeSwitcherKey } from 'hooks/useCurrentColorTheme'

// Types
import {
  CONFIRM_EMAIL_ACTION,
  CONFIRM_EMAIL_RESULT,
  EDIT_USER_INFO,
  GET_COUNTRIES_LIST,
  GET_USER_BALANCE,
  GET_USER_INFO,
  SET_COUNTRIES_LIST,
  SET_SELECTED_APP_LANGUAGE,
  SET_SELECTED_THEME,
  SET_USER_BALANCE,
  SET_USER_CURRENT_TRADING_ACCOUNT,
  SET_USER_DEVICE_IS_MOBILE,
  SET_USER_INFO,
  SET_USER_RATES,
  SET_USER_SIDEBAR_ACTIVE_ITEM,
  SET_USER_TRADING_ACCOUNTS,
} from 'store/actions/User/types'

const initialState = {
  sidebarActiveItem: sidebarConstants.personalInfo,
  userInfo: null,
  loadingUserInfo: false,
  loadingEditingUserInfo: false,
  loadingConfirmEmail: false,
  selectedLanguage: localStorage.getItem(appLanguagesLocalStoreKey) || appLanguages?.en,
  selectedTheme: localStorage.getItem(themeSwitcherKey) || themeColorMode.dark,
  countriesList: [],
  countriesListLoading: false,
  userBalance: null,
  userBalanceLoading: true,
  tradingAccounts: [],
  currentTradingAccount: null,
  rates: null,
  isMobile: false,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SIDEBAR_ACTIVE_ITEM:
      return produce(state, (draft) => {
        draft.sidebarActiveItem = action.payload
      })

    case SET_USER_INFO:
      return produce(state, (draft) => {
        draft.userInfo = action.payload
        draft.loadingUserInfo = false
        draft.loadingEditingUserInfo = false
      })

    case GET_USER_INFO:
      return produce(state, (draft) => {
        draft.loadingUserInfo = true
      })

    case EDIT_USER_INFO:
      return produce(state, (draft) => {
        draft.loadingEditingUserInfo = true
      })

    case CONFIRM_EMAIL_ACTION:
      return produce(state, (draft) => {
        draft.loadingConfirmEmail = true
      })

    case CONFIRM_EMAIL_RESULT:
      return produce(state, (draft) => {
        draft.loadingConfirmEmail = false
      })

    case SET_SELECTED_APP_LANGUAGE:
      return produce(state, (draft) => {
        draft.selectedLanguage = action.payload
      })

    case SET_SELECTED_THEME:
      return produce(state, (draft) => {
        draft.selectedTheme = action.payload
      })

    case SET_COUNTRIES_LIST:
      return produce(state, (draft) => {
        draft.countriesList = action.payload
        draft.countriesListLoading = false
      })

    case GET_COUNTRIES_LIST:
      return produce(state, (draft) => {
        draft.countriesListLoading = true
      })

    case SET_USER_BALANCE:
      return produce(state, (draft) => {
        draft.userBalance = action.payload
        draft.userBalanceLoading = false
      })

    case GET_USER_BALANCE:
      return produce(state, (draft) => {
        draft.userBalanceLoading = true
      })

    case SET_USER_TRADING_ACCOUNTS:
      return produce(state, (draft) => {
        draft.tradingAccounts = action.payload
      })

    case SET_USER_CURRENT_TRADING_ACCOUNT:
      localStorage.setItem(
        localStorageActiveUserTradeAccountKey,
        JSON.stringify(action.payload || {}),
      )

      return produce(state, (draft) => {
        draft.currentTradingAccount = action.payload
      })

    case SET_USER_RATES:
      return produce(state, (draft) => {
        draft.rates = action.payload
      })

    case SET_USER_DEVICE_IS_MOBILE:
      return produce(state, (draft) => {
        draft.isMobile = action.payload
      })

    default:
      return state
  }
}

export default userReducer
